module.exports = __webpack_public_path__ + "img/icon-phone.1a4a2d35.svg";